import { Component, ViewChild } from '@angular/core';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { environment } from 'src/environments/environment';
import { InMessageService } from './in-message.service';

@Component({
  selector: 'app-in-message',
  templateUrl: './in-message.component.html',
  styleUrls: ['./in-message.component.scss'],
})
export class InMessageComponent {
  url: string;
  canCustomize = false;
  customization = false;
  chatPosition: string;

  @ViewChild('inmessageIframe') iframe: any;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private customRouter: CustomRouter,
    inMessageService: InMessageService
  ) {
    const { pageId, version, extras } = customRouter.params;
    let canCustomize = false;
    if (version === '1') {
      const url = `${environment.apiURLPrefix}/inmessage-chat/${this.alcmeonContextService.companyId}/${pageId}`;
      this.alcmeonContextService.addJwtShortToUrl(url, true).subscribe(urlWithJwt => {
        this.iframe.nativeElement.setAttribute('src', urlWithJwt);
      });
      this.canCustomize = alcmeonContextService.isAlcmeonUser();
    } else {
      inMessageService.getPageInformation(pageId).subscribe({
        next: (
          pageInformation: { version: string; position: string; full_customized: boolean } = {
            version: '2',
            position: 'bottom-right-corner',
            full_customized: false,
          }
        ) => {
          if (pageInformation.position === 'bottom-left-corner') {
            this.chatPosition = 'bottom-left-corner';
          }

          canCustomize = !pageInformation.full_customized || alcmeonContextService.isAlcmeonUser();

          if (version !== '2' && `${pageInformation.version}` === '1' && (extras || '').indexOf('customization') < 0) {
            this.redirectToVersion1();
          }
          let url = `${environment.apiURLPrefix}/inmessage-chat-v2/${this.alcmeonContextService.companyId}/${pageId}`;
          if (extras) {
            let values = extras;
            values += `&language=${alcmeonContextService.self.lang}`;
            values += `&email=${alcmeonContextService.self.email}`;
            if (!canCustomize) {
              values = values.replace('advanced', '');
            }
            url += `?extras=${values}`;
          }
          this.alcmeonContextService.addJwtShortToUrl(url, true).subscribe(urlWithJwt => {
            this.iframe.nativeElement.setAttribute('src', urlWithJwt);
          });
          this.canCustomize = canCustomize;
        },
      });
    }

    this.customization = (extras || '').split(',').some(extra => extra === 'customization');
  }

  enableCustomization() {
    const { name } = this.customRouter.current;
    this.customRouter.transitionTo(
      name,
      { extras: 'customization', version: '2', language: this.alcmeonContextService.self.lang },
      {
        reload: true,
        inherit: true,
        notify: true,
      }
    );
  }

  disableCustomization() {
    const { name } = this.customRouter.current;
    this.customRouter.transitionTo(
      name,
      { extras: undefined, version: undefined, language: undefined },
      {
        reload: true,
        inherit: true,
        notify: true,
      }
    );
  }

  private redirectToVersion1() {
    const { name } = this.customRouter.current;
    this.customRouter.transitionTo(
      name,
      { extras: undefined, version: 1, language: undefined },
      {
        reload: true,
        inherit: true,
        notify: true,
      }
    );
  }
}
